import { Footer } from "components/Footer";
import React from "react";
import { useTranslation } from "react-i18next";

import "twin.macro";

export const CartConfirmed: React.FC<{}> = () => {
  const { i18n } = useTranslation();

  return (
    <div tw="flex space-x-2">
      <div tw="flex flex-col space-x-2 w-full">
        <div>
          <div tw="flex w-full justify-between px-6">
            <div tw="text-gray-500">{i18n.language === "it" ? "CARRELLO CONFERMATO" : "CART CONFIRMED"}</div>
          </div>
        </div>

        <div tw="flex justify-between w-full mt-64 mb-64">
          <div tw="w-full text-center text-2xl">
            {i18n.language === "it"
              ? "Grazie! La sua proposta ordine è stata inoltrata. Riceverà a breve una mail di conferma"
              : "Thank you! Your order proposal has been forwarded. You will receive shortly a confirmation by mail."}
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};
